/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Typography, IconButton } from '@mui/material';
import { BsArrowLeftShort } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
const BackButton = ({ pageTitle }) => {
  const navigate = useNavigate();
  return (
    <>
      <Typography color="primary" variant="h4" style={{ fontWeight: '700' }}>
        <IconButton color="primary" onClick={() => { navigate(-1) }}>
          <BsArrowLeftShort className="backButtonICon" size={30} /><Typography
            variant="h5" style={{ display: 'inline-block', paddingLeft: '5px' }}> </Typography>
        </IconButton>   {pageTitle}
      </Typography>
    </>
  )

}
export default BackButton;